import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';
import useTracking from '@gameday/utils/hooks/useTracking';
import { Title, Leaderboard, Icon, PlayerofTheGameSkeleton } from './PlayerOfTheGame.style';
import VotingDisplay from './components/VotingDisplay';
import WinnersDisplay from './components/WinnersDisplay';

const PlayerOfTheGame = ({
    leaderboardLink,
    deviceInteraction,
    winnersConfig,
    voteLink,
    language,
    ContentContainer,
    trackingProps,
    displayVote
}) => {
    const translate = useTranslate();
    const Tracking = useTracking();

    const handleOnClick = useCallback((e) => {
        const anchorEl = e?.currentTarget;
        const { componentName = [] } = trackingProps;
        const cfg = {
            componentName: componentName.concat(['Player of the Game Leaderboard']),
            text: e?.currentTarget?.innerText || '',
            activity: ' Link Click'
        };
        Tracking.track.track_click(cfg);

        if (anchorEl && deviceInteraction) {
            const link = anchorEl.getAttribute('href');
            if (deviceInteraction.webview({ url: link })) {
                e.preventDefault();
                return false;
            }
        }
    }, [deviceInteraction]);
    const {
        winners,
        isLoadingStories,
        isLoadingWinners
    } = winnersConfig;
    return (
        <>
            <Title>{translate('player_of_the_game', 'Player of the Game')}</Title>
            {isLoadingWinners
                ? (
                    <PlayerofTheGameSkeleton height={'185px'} width={'250px'}/>
                )
                : (
                    winners?.length > 0
                        ? (
                            <WinnersDisplay trackingProps={trackingProps} winners={winners} isLoadingStories={isLoadingStories} language={language}/>
                        )
                        : (
                            displayVote && <VotingDisplay
                                ContentContainer={ContentContainer}
                                deviceInteraction={deviceInteraction}
                                voteLink={voteLink}
                                language={language}
                                trackingProps={trackingProps}
                            />
                        )
                )
            }
            <Leaderboard href={leaderboardLink} target="_blank" onClick={handleOnClick}>
                {translate('button_see_leaderboard', 'Leaderboard')}
                <Icon name='arrow-next' width={10} />
            </Leaderboard>
        </>
    );
};

PlayerOfTheGame.propTypes = {
    ContentContainer: PropTypes.func,
    voteLink: PropTypes.string,
    leaderboardLink: PropTypes.string,
    deviceInteraction: PropTypes.object,
    language: PropTypes.string,
    winnersConfig: PropTypes.object,
    trackingProps: PropTypes.object
};

export default PlayerOfTheGame;
